interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "CVE";
};

const CVE: Currency = Object.freeze({
  "displayName": "Cape Verde Escudo",
  "numericCode": 132,
  "defaultFractionDigits": 0,
  "subUnit": 1,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "CVE",
  "symbol": "$"
});

export { CVE };
